import { useNavigation } from "@react-navigation/native";
import { IconButton } from "react-native-paper";
import { SubjectSpec } from "../common/subject";
import { HasScripts } from "../common/has-scripts";
import { useContext } from "react";
import { ProjectContext } from "../data/projectContext";

export function ScriptButton({
  parent,
  wholeEpisode,
  color,
  subjectKind,
  subjectName,
}: {
  parent: HasScripts | undefined;
  wholeEpisode?: boolean;
  color?: string;
} & Partial<SubjectSpec>) {
  const { navigate } = useNavigation();
  const { categories } = useContext(ProjectContext);
  const isPA = categories.includes("pa");
  const hasScripts = parent?.hasScripts;
  if (!hasScripts && (wholeEpisode || !parent || !isPA)) return null;
  return (
    <IconButton
      icon={hasScripts ? "script-text" : "script-text-outline"}
      iconColor={color}
      onPress={() =>
        navigate("script", {
          [wholeEpisode ? "episodePath" : "scenePath"]: parent.path,
          subjectKind,
          subjectName,
        })
      }
    />
  );
}
